export enum LiveStreamFeedType {
    Original = "Original",
    FaceAnonymized = "FaceAnonymized",
    PersonAnonymized = "PersonAnonymized",
}
